<template>
  <div
    class="prepaywall-footer"
    :class="{
      'position-absolute': isPositionAbsolute,
      'not-position-absolute': !isPositionAbsolute,
    }"
  >
    <div
      class="prepaywall-footer_title font-weight-bold font_size_1500rem text-center mt-5"
    >
      Sign up for free to continue using Phairify
    </div>
    <div class="prepaywall-footer_description mt-5">
      Phairify illustrates the market for specific physician services and connects recruiters and engaged physicians on job
      opportunities.
    </div>
    <div class="prepaywall-footer_subdescription mt-3 text-center">
      Join the marketplace today and find physicians that want your job.
    </div>
    <div
      class="prepaywall-footer_btn-wrapper mt-5 d-flex align-items-center justify-content-center"
    >
      <b-button
        variant="kowloon"
        to="/welcome/recruiter/ico"
        class="text-uppercase py-3 px-5 font-weight-bold"
      >
        Get started connecting with candidates!
      </b-button>
    </div>
    <div class="mt-5 text-center">
      Already have an account? <router-link to="/login">Sign in.</router-link>
    </div>
  </div>
</template>

<script>
import ImageUrlMixin from '@/mixins/ImageUrlMixin';

export default {
  name: 'CallToActionSection',
  mixins: [ImageUrlMixin],
  props: {
    isPositionAbsolute: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.prepaywall {
  &-footer {
    box-shadow: 0px 3px 20px #0000001a;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    z-index: 100;
    height: 630px;
    &.not-position-absolute {
      margin-top: 60px;
      padding-top: 50px;
    }
    &_description {
      padding: 0px 22%;
      text-align: center;
    }
  }
  &-modal {
    &_body {
      padding: 10px 140px 0px 110px;
    }
  }
}
//sm
@media (max-width: 767px) {
  .prepaywall {
    &-footer {
      &_description {
        padding: 0;
      }
    }
  }
}
//md
@media (min-width: 768px) {
}
//lg
@media (min-width: 991px) {
}
//xl
@media (min-width: 1200px) {
}
</style>
